/**
 * @module FieldControls
 */
import { TextField, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
const invalidCharacters = ['%', '\\', '*', '~'];
/**
 * Field control that represents a ShortText field. Available values will be populated from the FieldSettings.
 */
export const Name = props => {
  var _props$localization;
  const localization = deepMerge(defaultLocalization.name, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.name);
  const initialState = props.fieldValue && props.fieldValue.replace(/<[^>]*>/g, '') || props.actionName === 'new' && changeTemplatedValue(props.settings.DefaultValue) || '';
  const [value, setValue] = useState(initialState);
  const [isValid, setIsValid] = useState(true);
  const handleChange = event => {
    var _props$fieldOnChange;
    setIsValid(true);
    setValue(event.target.value);
    if (invalidCharacters.some(c => event.target.value.includes(c))) {
      setIsValid(false);
      return;
    }
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, event.target.value);
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(TextField, {
        autoFocus: props.autoFocus,
        autoComplete: "off",
        name: props.settings.Name,
        id: props.settings.Name,
        label: props.settings.DisplayName,
        placeholder: props.settings.DisplayName,
        value: value,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        fullWidth: true,
        onChange: handleChange,
        error: !isValid,
        helperText: isValid ? props.hideDescription ? undefined : props.settings.Description : `${localization.invalidCharactersError} ${invalidCharacters.join(',')}`
      });
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true
      }, props.fieldValue || localization.noValue));
  }
};
//# sourceMappingURL=name.js.map